import React, {useContext, useState} from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {IndividualContext} from "../../individual-context.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";

const Sos = () => {
    const navigate = navigateHook();
    const {individualInfo} = useContext(IndividualContext)

    const [columnDefs] = useState([
        {headerName: "Nome", field: "name", flex: 1},
        {headerName: "CPF/CNPJ", field: "cpf", width: 130,
            cellRenderer: ({value, data}) => {
                if (value) return projectUtils.formatCpfToView(value)

                return projectUtils.formatCnpjToView(data.cnpj)
            }
        },
        {headerName: "Programa de proteção", field: "protectionProgram",
            valueFormatter: ({value}) => value.map(v => v.name).join(", ")},
    ]);

    const onRowClicked = ({data}) => {
        navigate(`/sos/citizens/form/${data.id}`, true);
    }

    return (
        <Card>
            <Card.Header className={"gap-2"}>
                <Card.Title>
                    SOS
                </Card.Title>
            </Card.Header>
            <Card.Body>
                <div className={"aggrid-row-pointer h-[calc(100vh-185px)]"}>
                    <AgGridReact
                        rowData={individualInfo?.sos}
                        columnDefs={columnDefs}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={aggridUtils.generalTheme()}
                        onRowClicked={onRowClicked}
                    />
                </div>
            </Card.Body>
        </Card>
    );
};

export default Sos;